import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fileInput', 'image']

  openFileDialog() {
    this.fileInputTarget.click()
  }

  changeLogo(event) {
    const file = event.target.files[0]
    if (file) {
      // Check if this is a new partner by looking at the form action
      const form = this.element.closest('form')
      const actionUrl = form.getAttribute('action')
      const isNewPartner = !actionUrl.match(/\/\d+$/) // No ID in URL means new partner

      if (isNewPartner) {
        // For new partners, just preview the image without uploading
        this.previewImage(file)
        return
      }

      this.showLoading()
      
      // Create FormData and submit via AJAX (existing partner only)
      const formData = new FormData()
      formData.append('marketplace_partner[logo]', file)

      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

      fetch(actionUrl, {
        method: 'PATCH',
        body: formData,
        headers: {
          'X-CSRF-Token': csrfToken,
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        if (data.success) {
          // Update the image with the new logo URL
          this.updateImage(data.logo_url)
          this.hideLoading()
          this.showSuccess()
        } else {
          this.hideLoading()
          this.showError(data.errors || 'Failed to upload logo')
        }
      })
      .catch(error => {
        console.error('Error:', error)
        this.hideLoading()
        this.showError('Failed to upload logo')
      })
    }
  }

  updateImage(logoUrl) {
    const imageElement = this.imageTarget
    if (imageElement.tagName === 'IMG') {
      imageElement.src = logoUrl
    } else {
      imageElement.innerHTML = `<img src="${logoUrl}" style="width: 200px; height: 150px; object-fit: contain; object-position: center; border: 2px solid #e9ecef; border-radius: 8px; background: #f8f9fa;" />`
    }
  }

  showLoading() {
    const overlay = this.element.querySelector('.partner-logo-overlay')
    overlay.innerHTML = '<i class="fas fa-spinner fa-spin"></i><span>Uploading...</span>'
    overlay.style.opacity = '1'
  }

  hideLoading() {
    const overlay = this.element.querySelector('.partner-logo-overlay')
    overlay.innerHTML = '<i class="fas fa-camera"></i><span>Change Logo</span>'
    overlay.style.opacity = '0'
  }

  showSuccess() {
    const overlay = this.element.querySelector('.partner-logo-overlay')
    overlay.innerHTML = '<i class="fas fa-check"></i><span>Uploaded!</span>'
    overlay.style.opacity = '1'

    // Hide success message after 2 seconds
    setTimeout(() => {
      this.hideLoading()
    }, 2000)
  }

  showError(message) {
    const overlay = this.element.querySelector('.partner-logo-overlay')
    overlay.innerHTML = '<i class="fas fa-exclamation-triangle"></i><span>Error</span>'
    overlay.style.opacity = '1'

    alert(message)

    setTimeout(() => {
      this.hideLoading()
    }, 3000)
  }

  previewImage(file) {
    // For new partners, just show a preview of the selected image
    const reader = new FileReader()
    reader.onload = (e) => {
      this.updateImage(e.target.result)
    }
    reader.readAsDataURL(file)
  }
}
